import L from "leaflet";
import { typeMeta } from "./adventureConstants";

// small inline glyphs (white) per marker type
const GLYPH = {
  trek: '<path d="M3 20l6-11 4 6 2-3 6 8z"/>',
  trekking: '<path d="M3 20l6-11 4 6 2-3 6 8z"/>',
  culture: '<path d="M4 21h16M6 21V10l6-5 6 5v11M10 21v-5h4v5"/>',
  heritage: '<path d="M4 21h16M6 21V10l6-5 6 5v11M10 21v-5h4v5"/>',
  accommodation: '<path d="M3 21V9l9-6 9 6v12h-6v-6H9v6z"/>',
  transport: '<path d="M4 16V6h16v10M4 16h16M7 20v-2M17 20v-2M7 12h4M13 12h4"/>',
  airport: '<path d="M21 16l-9-4V4l-1-1-1 1v8l-9 4v2l9-2v4l-2 1v2l4-1 4 1v-2l-2-1v-4l9 2z"/>',
  wildlife: '<path d="M6 8c0-3 3-4 6-4s6 1 6 4c0 4-3 7-6 10C9 15 6 12 6 8z"/>',
  wellness: '<path d="M12 3c3 4 3 8 0 12-3-4-3-8 0-12zM6 10c4 1 6 4 6 8-4-1-6-4-6-8zM18 10c-4 1-6 4-6 8 4-1 6-4 6-8z"/>',
  adventure: '<path d="M12 2l2 6 6 .5-4.5 4 1.5 6-5-3.5L7 18.5 8.5 12.5 4 8.5 10 8z"/>',
  city: '<path d="M4 21V8h6v13M14 21V4h6v17M4 21h16"/>',
};

function svgWrap(inner, size = 13) {
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

export function quietIcon(type) {
  const meta = typeMeta(type);
  const glyph = GLYPH[type] || GLYPH.adventure;
  return L.divIcon({
    className: "adv-marker",
    html: `<div class="adv-pin" style="background:${meta.color}">${svgWrap(glyph, 13)}</div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -28],
  });
}

export function numberedIcon(n) {
  return L.divIcon({
    className: "adv-marker",
    html: `<div class="adv-pin numbered"><span>${n}</span></div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 34],
    popupAnchor: [0, -32],
  });
}
